export default __webpack_public_path__ + "static/media/iconHomeBook.ceed4dcd.svg";